import { LongRunningContextCategoryTyp } from '../../../../samwebDescription/samweb/waitingContext/waitingContextCategory';

export function LongRunningAction(waitingContextCategory: LongRunningContextCategoryTyp) {
   // tslint:disable-next-line:only-arrow-functions ban-types
   return function (Class: Function) {
      Object.defineProperty(Class.prototype, 'waitingContextCategoryFromDecorator', {
         value: waitingContextCategory,
      });
   };
}
